<template>
  <v-card>
    <v-dialog
      v-model="dialogNewUser"
      width="500"
    >

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Upload a file
        </v-card-title>

        <v-card-text>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="dialogNewUser = false"
          >
            I accept
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


   <v-toolbar color="blue-grey darken-2" dark>

     <v-toolbar-title><span @click="">Users</span> / {{users[0].name}}</v-toolbar-title>

     <v-spacer></v-spacer>

     <v-btn icon @click="deleteUser(users[0])">
       <v-tooltip bottom>
         <template v-slot:activator="{ on }">
           <v-icon color="grey lighten-1" v-on="on">delete_forever</v-icon>
         </template>
         <span>Delete</span>
      </v-tooltip>
     </v-btn>

     <!-- <v-btn icon @click="dialogUpload = true">
       <v-icon>cloud_upload</v-icon>
     </v-btn>

     <v-btn icon @click="dialogFolder = true">
       <v-icon>create_new_folder</v-icon>
     </v-btn> -->
   </v-toolbar>

   <v-list v-if="users.length > 0" two-line subheader>
     <v-subheader inset>Name</v-subheader>
     {{users[0].name}}
     <v-divider inset></v-divider>
     <v-subheader inset>Company</v-subheader>
     {{users[0].company}}
     <v-divider inset></v-divider>
     <v-subheader inset>Email</v-subheader>
     {{users[0].email}}
     <v-divider inset></v-divider>
     <v-subheader inset>Suspended</v-subheader>
     {{users[0].isSuspended}}
     <v-divider inset></v-divider>
     <v-subheader inset>Administrator</v-subheader>
     {{users[0].isAdmin}}
     <v-divider style="margin-bottom: 20px" inset></v-divider>
   </v-list>
 </v-card>

</template>


<script>
  import firebase from 'firebase'
  import db from '../../main.js'
  import {store} from '../../store/store.js'
  import Vuex from 'vuex'

  export default {
    name: 'UserManager',
    props: ['user'],
    data: function() {
      return {
        dialogNewUser: false,
        name: null,
        company: null,
        companyName: '',
        email: null,
        isAdmin: null,
        isSuspended: null,
        users: []
      }
    },
    methods: {
      updateData() {
        var self = this;
        self.users=[];
        db.collection('users').where('id', '==', self.user.id).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let data = {
              'uid': doc.id,
              'name': doc.data().firstName + ' ' + doc.data().lastName,
              'company': doc.data().company,
              'email': doc.data().email,
              'isAdmin': doc.data().isAdmin,
              'isSuspended': doc.data().isSuspended
            }
            self.users.push(data);
            console.log(self.users[0]);
          })
        })
      },
      getCompanyName(id) {
        var self = this;
        db.collection('companies').where('id', '==', id).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            return doc.data().name;
          })
        })
      },
      deleteUser(user) {
        var self = this;
        var userConfirm = confirm("Are you sure you want to delete " + user.firstName + " " + user.lastName + "?");
        if (userConfirm == true) {
          db.collection("users").doc(user.uid).delete().then(function() {
            console.log(user + " deleted");
            document.location.reload();
          }).catch(function(error) {
            console.log("There was an error deleting this user " + error);
          });
        } else {
          console.log("You just saved somebody's life");
        }
      },
      openFolder(folder) {

      },
    },
    watch: {
        user: function(newVal, oldVal) { // watch it
          this.updateData();
        }
    },
    mounted() {
      var self = this;
      this.updateData();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
